module.exports = __webpack_public_path__ + "img/1.80a63f38.png";